import script from "./RubikMain.vue?vue&type=script&setup=true&lang=js"
export * from "./RubikMain.vue?vue&type=script&setup=true&lang=js"

import "./RubikMain.vue?vue&type=style&index=0&id=97766316&lang=css"

const __exports__ = script;

export default __exports__